<template>
  <div
    :ref="playlistId"
    class="mc-trackvideo-card__item"
    :class="{
      'mc-trackvideo-card__item--fullscreen': playlistItem.fullscreen,
      'mc-trackvideo__main-playlist':
        arrKeyPlaylistIsPlay.findIndex((id) => id === playlistId) === 0,
    }"
  >
    <div class="mc-trackvideo-card__item-wrapper">
      <div
        class="mc-trackvideo-card-header-bg-1"
        :style="`background-color: ${listColor[uniqueVehicleIds.indexOf(playlistItem.vehicleId)]}`"
      >
        <span class="mc-trackvideo-card-header-label" :title="headerTitle">
          {{ headerTitle }}
        </span>
      </div>
      <div class="mc-trackvideo-card-body">
        <div class="mc-trackvideo-card-body-content">
          <VideoTimeout
            v-show="playlistItem.videoStatus === 'timeout'"
            @clickContinue="clickContinueStream(index, playlistItem)"
          />
          <Connecting v-show="playlistItem.videoStatus === 'connecting'" />
          <NoFeedBack
            v-show="playlistItem.videoStatus === 'error'"
            @clickTryAgain="onClickTryAgain(index, playlistItem)"
          />
          <MeVideo
            v-show="playlistItem.videoStatus === 'ready' && !playlistItem.refresh"
            v-if="!isRemoved && playlistItem.videoStatus !== 'timeout'"
            :ref="`videoPlayer${playlistItem.vehicleId}-${index}`"
            :source="playlistItem"
            :index="index"
            :playlistId="playlistId"
            @startPlay="onStartPlay(index, playlistItem)"
            @ready="onPlayerReady(index, playlistItem)"
            @error="onPlayerError(index, playlistItem)"
            @pause="pauseVideo(index, playlistItem)"
            @mute="muteVideo(index, playlistItem)"
            @fullscreen="onFullscreen(index, playlistItem)"
            @setPlaylistReady="setPlaylistVideoStatusReady(index.playlistItem)"
            @setPlaylistTimeout="setPlaylistVideoStatusTimeout(index, playlistItem)"
            @connecting="connecting(index, playlistItem)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NoFeedBack from './State/NoFeedBack'
import Connecting from './State/Connecting'
import VideoTimeout from './State/Timeout.vue'
import MeVideo from './State/Video'
import { Helper } from '@/mixin/helper'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'VideoItem',
  components: {
    NoFeedBack,
    Connecting,
    VideoTimeout,
    MeVideo,
  },
  mixins: [Helper],
  props: {
    index: {
      type: Number,
      required: true,
    },
    playlistId: {
      type: String,
      required: true,
    },
    playlist: {
      type: Object,
      required: true,
    },
    arrKeyPlaylistIsPlay: {
      type: Array,
      required: true,
    },
    uniqueVehicleIds: {
      type: Array,
      required: true,
    },
    gridState: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      playlistItem: this.playlist,
      listColor: [
        '#3D69A7',
        '#082957',
        '#A56DE5',
        '#562C85',
        '#D64AA8',
        '#7A1158',
        '#478EE1',
        '#114683',
        '#06172C',
        '#083222',
        '#663700',
        '#620C00',
        '#344264',
        '#01133D',
        '#310600',
        '#331C00',
      ],
    }
  },
  computed: {
    gridActive() {
      const numGrid = {
        gridOne: 1,
        gridFour: 4,
        gridSix: 6,
        gridEight: 8,
        gridNine: 9,
      }
      return numGrid[this.gridState]
    },
    isRemoved() {
      return this.playlist.isRemoved
    },
    headerTitle() {
      return (
        this.playlistItem.licensePlate +
        ' - ' +
        `${this.$t('trackVideo.camera')} ${this.playlistItem.camera}`
      )
    },
    isVssHowen() {
      return this.playlistItem.deviceType === 'vss-howen'
    },
  },
  async mounted() {
    this.setPlaylistValue(`${this.playlistItem.id}:${this.index}`, 'videoStatus', 'connecting')
    await this.delay(1000)
    if (this.isVssHowen) {
      this.setPlaylistValue(`${this.playlistItem.id}:${this.index}`, 'videoStatus', 'ready')
    }
  },
  methods: {
    setPlaylistValue(playlistId, key, value) {
      this.$emit('setPlaylistValue', playlistId, key, value)
    },
    connecting(index, data) {
      this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'connecting')
    },

    setPlaylistVideoStatusTimeout(index, data) {
      setTimeout(() => {
        this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'timeout')
        this.$forceUpdate()
      }, 300)
    },

    setPlaylistVideoStatusReady(index, data) {
      setTimeout(() => {
        this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'ready')
        this.$forceUpdate()
      }, 300)
    },

    async onStartPlay(index, data) {
      const isJc = data.deviceType === 'jc'
      const imei = this.$store.state.video.fleets.find(
        (vehicle) => vehicle.vehicleId === parseInt(data.vehicleId)
      ).vehicle.imei
      const channel = isJc ? (parseInt(data.channel) + 1).toString() : data.channel
      await this.$store.dispatch('video/requestOnlineCommandStreamStatus', {
        channels: [channel],
        imei,
        status: true,
        statsDataV2: {
          inputDataPlay: {
            channel: channel,
            id: data.uid,
          },
        },
      })
    },

    onPlayerReady(index, data) {
      setTimeout(() => {
        this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'ready')
        this.$forceUpdate()
        const videoPlayerRefs = `videoPlayer${data.vehicleId}-${index}`
        this.$refs[videoPlayerRefs].$refs[`videoPlayer${data.id}`].player.muted = true
      }, 300)
    },

    onPlayerError(index, data) {
      setTimeout(async () => {
        this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'error')
        this.$forceUpdate()
        const imei = this.$store.state.video.fleets.find(
          (vehicle) => vehicle.vehicleId === parseInt(data.vehicleId)
        ).vehicle.imei

        const isJc = data.deviceType === 'jc'
        const channel = isJc ? (parseInt(data.channel) + 1).toString() : data.channel

        await this.$store.dispatch('video/requestOnlineCommandStreamStatus', {
          channels: [channel],
          imei,
          status: true,

          statsDataV2: {
            inputDataTryAgain: {
              channel,
              id: data.uid,
            },
          },
        })
      }, 300)
    },

    pauseVideo(index, data) {
      this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'pause')
      this.$forceUpdate()

      const videoPlayerRefs = `videoPlayer${data.vehicleId}-${index}`
      this.$refs[videoPlayerRefs].$refs[`videoPlayer${data.id}`].player.pause()
      this.$refs[videoPlayerRefs].$refs[`videoPlayer${data.id}`].player.muted = true
    },

    muteVideo(index, data) {
      this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'ready')
      this.$forceUpdate()

      const videoPlayerRefs = `videoPlayer${data.vehicleId}-${index}`

      this.$refs[videoPlayerRefs].$refs[`videoPlayer${data.id}`].player.muted =
        !this.$refs[videoPlayerRefs].$refs[`videoPlayer${data.id}`].player.muted
    },

    async onFullscreen(index, data) {
      this.setPlaylistValue(`${data.id}:${index}`, 'fullscreen', !this.playlistItem.fullscreen)

      await this.$nextTick()

      this.$forceUpdate()

      if (this.playlistItem.fullscreen) {
        var elem = document.documentElement

        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen()
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen()
        }
      }
    },

    clickContinueStream(index, row) {
      if (this.isVssHowen) {
        this.startNewSessionStreamVss(index, row)
      } else {
        this.startNewSessionStream(index, row)
      }
    },

    async startNewSessionStreamVss(index, row) {
      this.setPlaylistValue(`${row.id}:${index}`, 'videoStatus', 'connecting')
      await this.delay(1000)
      this.setPlaylistValue(`${row.id}:${index}`, 'videoStatus', 'ready')

      this.$forceUpdate()
    },

    async onClickTryAgain(index, data) {
      await this.startNewSessionStream(index, data)
      this.$forceUpdate()

      this.reconnecting(index, data)
    },

    reconnecting(index, data) {
      this.setPlaylistValue(`${data.id}:${index}`, 'refresh', true)

      setTimeout(() => {
        this.setPlaylistValue(`${data.id}:${index}`, 'videoStatus', 'connecting')

        this.$forceUpdate()

        const videoPlayerRefs = `videoPlayer${data.vehicleId}-${index}`

        this.$refs[videoPlayerRefs].$refs[`videoPlayer${data.id}`].initialize()

        this.setPlaylistValue(`${data.id}:${index}`, 'refresh', false)
      }, 300)
    },

    async startNewSessionStream(index, row) {
      const imei = this.$store.state.video.fleets.find(
        (vehicle) => vehicle.vehicleId === parseInt(row.vehicleId)
      ).vehicle.imei

      const isJc = row.deviceType === 'jc'
      const channel = isJc ? (parseInt(row.channel) + 1).toString() : row.channel
      const uid = uuidv4()
      await this.$store.dispatch('video/setVideoStreamStatusPerVideo', {
        imei,
        channel: channel,
        status: true,
        statsDataV2: {
          inputDataRequest: [
            {
              channel,
              id: uid,
            },
          ],
        },
      })

      this.setPlaylistValue(`${row.id}:${index}`, 'videoStatus', 'connecting')

      this.setPlaylistValue(`${row.id}:${index}`, 'uid', uid)

      this.$forceUpdate()
    },

    getVehicleStatusByVehicleId(vehicleId) {
      return this.vehicleStatusByVehicleId(vehicleId)
    },
  },
}
</script>
